'use client'

import { useMemo } from 'react'
import { QuestionMark as QuestionMarkIcon } from '@mui/icons-material'

// Types
import type { IconProps } from '@/types/components/atoms/icons'

const IconComponents: { [key: string]: Promise<any> } = {
	Chart: import('@/components/atoms/icons/chart'),
	Crown: import('@/components/atoms/icons/crown'),
	DesignTool: import('@/components/atoms/icons/design-tool'),
	Down: import('@/components/atoms/icons/down'),
	Flash: import('@/components/atoms/icons/flash'),
	Receipt: import('@/components/atoms/icons/receipt'),
	SEO: import('@/components/atoms/icons/seo'),
	Shopify: import('@/components/atoms/icons/shopify'),
	Star: import('@/components/atoms/icons/star'),
	Timer: import('@/components/atoms/icons/timer'),
	WenDesign: import('@/components/atoms/icons/web-design'),
	WebSupport: import('@/components/atoms/icons/web-support')
}

const IconAtom = (props: IconProps) => {
	// Props
	const { name, children } = props

	// Variables
	const iconName = name || children || ''

	try {
		const IconCached = useMemo(async () => {
			const IconComponent = (await IconComponents[iconName])?.default

			return IconComponent ? <IconComponent /> : <QuestionMarkIcon />
		}, [iconName])

		return IconCached
	} catch (err) {
		console.error(`IconAtom: Error loading icon '${iconName}':`, err)

		return <QuestionMarkIcon />
	}
}

export default IconAtom
